import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Navbar from '../components/navbar/Navbar';
import { isSuperAdmin } from '../auth';
import s from './Layout.module.scss';

const navItems = [
    { to: '/home', label: 'Dashboard', icon: <DashboardOutlinedIcon fontSize="small" /> },
    { to: '/brands', label: 'Brands', icon: <LoyaltyOutlinedIcon fontSize="small" /> },
    { to: '/products', label: 'Products', icon: <SellOutlinedIcon fontSize="small" /> },
    { to: '/hero', label: 'Hero', icon: <ImageOutlinedIcon fontSize="small" /> },
    { to: '/settings', label: 'Settings', icon: <SettingsOutlinedIcon fontSize="small" />, superOnly: true },
];

export default function Layout() {
    return (
        <div className={s.shell}>
            <Navbar />

            <div className={s.mainWrap}>
                <aside className={s.sidebar}>
                    <Box className={s.sideTitle}>Catalog</Box>
                    <nav className={s.sideNav}>
                        {navItems
                            .filter((item) => !item.superOnly || isSuperAdmin())
                            .map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                className={({ isActive }) => `${s.sideLink} ${isActive ? s.sideLinkActive : ''}`}
                            >
                                <span className={s.icon}>{item.icon}</span>
                                <span>{item.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                </aside>

                <main className={s.content}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
